import React, { useState } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import { Input, Textarea, Button } from "components";
import { addQuestion } from "actions/questions";
import validate from "./validate";

const answers = [
  { label: "A", value: 0 },
  { label: "B", value: 1 },
  { label: "C", value: 2 },
  { label: "D", value: 3 },
];

const InputField = props => <Input {...props} />;
const TextareaField = props => <Textarea {...props} />;

const AddQuestion = ({ pristine, dispatch, handleSubmit, invalid, change, initialValues, addQuestion }) => {
  const [correct_value, setCorrectValue] = useState(initialValues.correct);
  const onSubmit = values => {
    const correct = values.correct;
    delete values.correct;
    const data = {
      ...values,
      question_options_attributes: values.question_options_attributes.map((item, index) => ({
        ...item,
        correct: index === correct,
      })),
    };
    addQuestion(data)
      .then(() => {
        setCorrectValue(initialValues.correct);
        dispatch(reset("add-question"));
      })
      .catch(err => console.log(err));
  };
  return (
    <div className="dashboard">
      <header className="dashboard__header">
        <h2 className="dashboard__title heading">Dodaj pytanie</h2>
        <Button disabled={pristine || invalid} onClick={handleSubmit(onSubmit)} type="save" text="Zapisz" />
      </header>
      <div className="dashboard__form">
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <Field label="Nowe pytanie*" name="content" component={TextareaField} />
          <h2 className="label-form answers">
            Odpowiedzi: <span>Oznacz poprawną odpowiedź*</span>
          </h2>
          <Field name="correct" component={InputField} type="hidden" />
          {answers.map(({ label, value }) => (
            <div className="answer-wrapper" key={value}>
              <div className="answer-content">
                <Field label={label} name={`question_options_attributes[${value}].content`} component={InputField} />
              </div>
              <div className="answer-correct">
                <input
                  type="checkbox"
                  id={`correnct[${value}]`}
                  checked={correct_value === value}
                  onChange={() => {
                    change("correct", value);
                    setCorrectValue(value);
                  }}
                />
                <label htmlFor={`correnct[${value}]`} />
              </div>
            </div>
          ))}
        </form>
      </div>
    </div>
  );
};
const mapDispatchToProps = dispatch => ({
  addQuestion: data => dispatch(addQuestion(data)),
});

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({ form: "add-question", enableReinitialize: true, validate, initialValues: { correct: 0 } })(AddQuestion));
